import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { promoHeaderSx, promoTitleSx } from "../../mobile-jigsaw/styles/mainStyles";

/**
 * Reveals title text one character at a time (OBS / App Store capture).
 */
export default function AnimationTypewriterTitle({
    text = "",
    charMs = 140,
    initialDelayMs = 500,
    variant = "header",
}) {
    const isOverlay = variant === "overlay";
    const [visibleCount, setVisibleCount] = useState(0);

    useEffect(() => {
        if (!text) {
            setVisibleCount(0);
            return undefined;
        }

        setVisibleCount(0);
        const timers = [];
        let delay = initialDelayMs;
        for (let i = 1; i <= text.length; i += 1) {
            const count = i;
            timers.push(
                window.setTimeout(() => {
                    setVisibleCount(count);
                }, delay),
            );
            delay += charMs;
        }

        return () => {
            timers.forEach((timer) => window.clearTimeout(timer));
        };
    }, [text, charMs, initialDelayMs]);

    const visible = text.slice(0, visibleCount);

    return (
        <Box
            sx={
                isOverlay
                    ? { textAlign: "center", px: 2 }
                    : { ...promoHeaderSx, minHeight: "5.5rem" }
            }
        >
            <Box
                component="h1"
                aria-label={text}
                sx={
                    isOverlay
                        ? {
                              fontFamily: "inherit",
                              fontWeight: 800,
                              fontSize: { xs: "2rem", sm: "2.35rem" },
                              lineHeight: 1.2,
                              letterSpacing: "0.08em",
                              textTransform: "uppercase",
                              color: "#ffffff",
                              textShadow:
                                  "0 2px 24px rgba(0,0,0,0.65), 0 0 1px rgba(0,0,0,0.85)",
                              m: 0,
                              minHeight: "1.2em",
                          }
                        : {
                              ...promoTitleSx,
                              fontFamily: "inherit",
                              m: 0,
                              minHeight: "1.2em",
                          }
                }
            >
                {visible}
                <Box
                    component="span"
                    aria-hidden
                    sx={{
                        display: visibleCount < text.length ? "inline-block" : "none",
                        width: "0.06em",
                        height: "0.85em",
                        ml: 0.15,
                        verticalAlign: "-0.08em",
                        bgcolor: "currentColor",
                        opacity: 0.55,
                        animation: "jigsawTypewriterCaret 0.9s step-end infinite",
                        "@keyframes jigsawTypewriterCaret": {
                            "0%, 100%": { opacity: 0 },
                            "50%": { opacity: 0.55 },
                        },
                    }}
                />
            </Box>
        </Box>
    );
}
